/*
* Copyright (c) 2023 Eugenio Espinoza
*
* Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"),
* to use the Software solely for personal, non-commercial purposes. Any commercial use, distribution, sublicense, sale, or modification of the Software
* is strictly prohibited without the explicit written permission of the copyright holder.
*
* For licensing inquiries, please contact Eugenio Espinoza at mail.eugenioespinoza.com .
*
* THE SOFTWARE IS PROVIDED "AS IS," WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

import React from 'react';
import { useState } from 'react';
import "./DubGProfile.css";

function DubGProfile() {

  const DubgGTours = [
    // {
    //   date: '2023-05-01',
    //   title: 'Tour 1',
    //   location: 'New York',
    //   ticketLink: 'https://example.com/tour-1-tickets',
    // },
    // {
    //   date: '2023-05-10',
    //   title: 'Tour 2',
    //   location: 'Los Angeles',
    //   ticketLink: 'https://example.com/tour-2-tickets',
    // },
    // {
    //   date: '2023-05-20',
    //   title: 'Tour 3',
    //   location: 'Chicago',
    //   ticketLink: 'https://example.com/tour-3-tickets',
    // },
  ];


  const formatDate = (dateString) => {
      const date = new Date(dateString);
      const month = date.toLocaleString('en-US', { month: 'short' });
      const day = date.getDate();
      const year = date.getFullYear();
      return `${month} ${day}, ${year}`;
    };
  const buyTicket = (tour) => {
    // alert(`Buying a ticket for ${tour.title} in ${tour.location} on ${tour.date}`);
    window.open(tour.ticketLink, '_blank');
  };

  

  /* Show More button Fuction */
  const [showFullBio, setShowFullBio] = useState(false);
  const handleToggleBio = () => {
    setShowFullBio(!showFullBio);
  };



  return (
    <div>
      <div className="dubg-banner">
        {/* <img className="profile-pic" src="https://i1.sndcdn.com/artworks-000012755519-fd1mrr-t500x500.jpg" alt="Artist Profile" /> */}
      </div>
  {/* Artist's About Section*/}
  <div className="artist-info-container">
    <div className="artist-excerpt-container">
      <h1 className="entry-title">Dub G</h1>
        <p>
        Dub G is a dynamic rap artist who seamlessly bridges the gap between English trap and Spanish rap, crafting a sound uniquely his own.
        With an innate talent for storytelling and a deep connection to his Mexican heritage, Dub G has emerged as a powerful voice in the rap scene.
        </p>
    {showFullBio ? (
      <>
      {[      
      "From a young age, Dub G was surrounded by music, thanks to his rapper friends and his constant immersion in the world of melodies and beats. ",
      "While his early exposure leaned towards English trap music, a pivotal moment came when he discovered the potential of rap in Spanish. ",
      "The vibrant Mexican rap scene ignited his creativity, inspiring him to fuse his linguistic prowess with his passion for rap.",
      "Dub G's songwriting is an unfiltered reflection of his life's journey, capturing every high and low, every triumph and struggle. ",
    "His music becomes a canvas where he paints his experiences, allowing listeners to connect on a deeply personal level.",
    "Dub G's lyrical compositions serve as windows into the issues of his community. His music speaks to the heart of societal struggles, amplifying voices that often go unheard.",
    "His perspective, influenced by both cultures, adds depth and complexity to his storytelling, enriching the tapestry of his artistry.",
    "His focus is on delivering good, relatable music that resonates with listeners on a personal level.", 
    "As he continues to enrich the rap scene with his fusion of English and Spanish,",
    "Dub G remains a compelling artist whose voice captivates and unites diverse audiences through the universal language of music."
      ].map((text, index) => (
          <React.Fragment key={index}>
            {text.endsWith(".") ? (
              <>
                {text}
                <br />
              </>
            ) : (
              <>{text}</>
            )}
          </React.Fragment>
        ))}
        <button className="see-more" onClick={handleToggleBio}> Ver Menos</button>
      </>
    ) : (
      <button className="see-more" onClick={handleToggleBio}> Ver Mas</button>
    )}
        <div className="social-links">
          <a href="https://www.instagram.com/dubskillaz/" rel="noopener noreferrer" target="_blank" className="artist-social-link">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="https://open.spotify.com/artist/5SVHvnw9UIDoLNC745Lt8V?go=1&sp_cid=dbd1830fdc7055475212c65e0ab00eb8&utm_source=embed_player_p&utm_medium=desktop&nd=1" rel="noopener noreferrer" target="_blank" className="artist-social-link">
            <i className="fab fa-spotify"></i>
          </a>
          <a href="https://www.youtube.com/channel/UCX_Ymdf_bsVEoP6BpZOGV0Q" rel="noopener noreferrer" target="_blank" className="artist-social-link">
            <i className="fab fa-youtube"></i>
          </a>
        </div>
      </div>
      <div className="artist-meta-container">
          <div className="artist-location artist-meta ">
              <h3>Ciudad</h3>
              <p></p>
            </div>
            <div className="artist-genre artist-meta">
              <h3>Genero</h3>
              <p>Rap</p>
            </div>
            <div className="artist-website artist-meta">
                <h3>Instagram</h3>
                <a href="https://www.instagram.com/dubskillaz/"rel="noopener noreferrer" target="_blank">
                  <span>@dubskillaz</span>
                </a>
            </div>
            <div className="artist-email artist-meta">
                <h3>Booking</h3>
                <a href="mailto: joe@masteredtrax.com" rel="noopener noreferrer">
                  <span>joe@masteredtrax.com</span>
                </a>
          </div>
      </div>
</div>
{/* Artist's Music Section*/}
  <div id='music'>
    <h1 className="music-section-title">MUSICA</h1>
    <div className="music-section">
      <div className="column youtube">
        <div className="music-wrap">
          <iframe
            title="YouTube Video"
            src="https://www.youtube.com/embed/qpgL5VPDc0g"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
      <div className="column spotify">
        <div className="music-wrap">
          <iframe
            title="Spotify Player"
            src="https://open.spotify.com/embed/artist/5SVHvnw9UIDoLNC745Lt8V?utm_source=generator&theme=0"
            width="100%"
            height="352"
            frameBorder="0"
            allowFullScreen=""
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>  
  </div>
{/* Artist's Tour Section*/}

<h1 className="tour-section-title">TOUR</h1>
<div className="tour-section">
  {DubgGTours.length === 0 ? (
    <p>No hay eventos programados.</p>
  ) : (
    <table className="tour-table">
      <thead>
        <tr>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {DubgGTours.map((tour, index) => (
          <tr key={index}>
            <td id='event-date'>{formatDate(tour.date)}</td>
            <td id="event-title">{tour.title}</td>
            <td id="event-location">{tour.location}</td>
            <td id="button-container">
              <button onClick={() => buyTicket(tour)}>Buy Ticket</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )}
</div>

</div>
  );
}
export default DubGProfile;